import styled from '@emotion/styled'

export const StyledBreadcrumbsContainer = styled.div`

    /* direction: rtl; */

`